enum EModalEntryId {
  LOGIN_MODAL = "LOGIN_MODAL",
  LOGOUT_MODAL = "LOGOUT_MODAL",
}

export default EModalEntryId;
